import differenceInDays from "date-fns/differenceInDays";
import parseISO from "date-fns/parseISO";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { DASH } from "common/constants";
import {
  convertDistanceToFurlongs,
  getDistanceClass
} from "utils/distance-utils";
import { parseCourseSurfaceForPC } from "utils/enum-parser";
import {
  getHorseAgeSexColorValue,
  getHorseOwnerOrBreederName
} from "utils/horse";

type THorseDetailValue = string | string[] | number;

export const SELECTED_HORSE_OPTIONS = [
  "id",
  "registrationNumber",
  "color",
  "gender",
  "birthday",
  "lifetime.starts",
  "lifetime.wins",
  "lifetime.place",
  "lifetime.show",
  "riskFactorShortDescriptions",
  "stateEligibleCode",
  "breeder.name",
  "owner.firstName",
  "owner.lastName",
  "lastRaceDate",
  "lastRaceType",
  "lastRaceCourseType",
  "lastRaceDistance",
  "lastRaceDistanceUnit",
  "lastWorkoutFacility.code",
  "lastWorkoutDate"
];

export const getValueOrDash = (value: THorseDetailValue): THorseDetailValue => {
  if (typeof value === "number") {
    return value ?? DASH;
  }

  return value || DASH;
};

const getBredState = (value: racehorse360.HorseStateEligibility): string => {
  switch (value) {
    case racehorse360.HorseStateEligibility.HORSE_STATE_ELIGIBILITY_CALIFORNIA:
      return "California";
    case racehorse360.HorseStateEligibility.HORSE_STATE_ELIGIBILITY_FLORIDA:
      return "Florida";
    case racehorse360.HorseStateEligibility.HORSE_STATE_ELIGIBILITY_MARYLAND:
      return "Maryland";
    default:
      return DASH;
  }
};

export const getHorseDetails = (
  horse: racehorse360.IHorse,
  raceReady: string
): { [key: string]: THorseDetailValue } => ({
  Owner: getHorseOwnerOrBreederName(horse),
  ["Race Ready"]: getValueOrDash(raceReady),
  ["C.S.A"]: getHorseAgeSexColorValue(horse, undefined, DASH),
  DLW: horse?.lastWorkoutDate
    ? differenceInDays(new Date(), parseISO(horse.lastWorkoutDate))
    : DASH,
  DLR: horse?.lastRaceDate
    ? `${differenceInDays(new Date(), parseISO(horse.lastRaceDate))}`
    : DASH,
  ["Surface - Distance"]: horse?.lastRaceCourseType
    ? `${parseCourseSurfaceForPC(horse.lastRaceCourseType)} -
          ${getDistanceClass(
            horse.lastRaceCourseType,
            convertDistanceToFurlongs(
              horse.lastRaceDistance,
              horse.lastRaceDistanceUnit
            )
          )}`
    : DASH,
  Classification: getValueOrDash(horse?.lastRaceType),
  ["Bred State"]: getBredState(horse?.stateEligibleCode),
  ["Races Won"]: getValueOrDash(horse?.lifetime?.wins),
  ["In Money"]: horse?.lifetime
    ? horse.lifetime.wins + horse.lifetime.place + horse.lifetime.show
    : DASH,
  ["Registration#"]: getValueOrDash(horse?.registrationNumber),
  ["Last Track Work"]: getValueOrDash(horse?.lastWorkoutFacility?.code),
  Risks: horse?.riskFactorShortDescriptions || DASH
});
